import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetModule } from '../../../widget/widget.module';
import { BussinessPostComponent } from '../../bussiness-post/bussiness-post.component';

@Component({
  selector: 'app-net-homepage',
  standalone: true,
  imports: [CommonModule, WidgetModule, BussinessPostComponent],
  templateUrl: './net-homepage.component.html',
  styleUrls: ['./net-homepage.component.scss']
})
export class NetHomepageComponent implements OnInit {


  constructor() { }

  ngOnInit() {
  }

}

